function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoData = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Calque_1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 1000 1000",
  style: {
    enableBackground: "new 0 0 1000 1000"
  },
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.9538 -0.3006 0.3006 0.9538 -124.4731 172.607)",
  style: {
    fill: "#DFDFDF"
  },
  cx: 498.7,
  cy: 490.8,
  rx: 271.4,
  ry: 312.2
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#A4A4A4"
  },
  d: "M161,435.8c0,0-36.5-90.6,32.8-194.8c19.4,23.5,40.4,27.1,40.4,27.1s34.7-91.9,142.8-144.5l8.7,31.8 c0,0,79.7-79.5,169.1-111.7c30.1,66.1,36.9,117.1,36.9,117.1l22-22.8c0,0,48,77.3,82.1,155.7c-69.4-52.2-139.2-67.4-139.2-67.4 c-71.8,58.4-200.6,100.4-200.6,100.4c26.5,86.9,37.9,184.1,42.6,237.7c1.5,17.4-17.3,29.2-32.3,20.3h0c-4.7-2.8-8.2-7.2-10-12.3 C329.1,492.1,319.8,444,273.5,456c-47.8,12.4-21.7,175.3,56.8,171.8c15.6,49.5,68.9,129.6,103.8,156.4 c-77.5-1.5-156.5-92-156.5-92l-9.9,40.3c0,0-108.4-74.6-101.2-195c-11.8,26.3-20.9,30.5-20.9,30.5S105.4,503.7,161,435.8z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#686868"
  },
  d: "M541.1,654.4c0,0,83.6-144.7,202.5-86.4C702.3,535.9,605.3,504.2,541.1,654.4z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#CFCFCF"
  },
  d: "M590.7,658.7c0,0,32.7-67.4,120.7-58.2C672.8,619.1,590.7,658.7,590.7,658.7z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#777777"
  },
  d: "M399.5,415.8l10.8,20l102.2-83.3c10.6-8.6,13.7-23.5,7.5-35.6l-6.7-13.1l-108.8,87.4 C397.2,397.2,395.1,407.5,399.5,415.8z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#777777"
  },
  d: "M586.1,282.5l3.1,16.6c2.1,11.4,12.3,19.5,23.9,19.1l83.2-3l1.9-8.7c2.3-10.6-5.6-20.6-16.4-21L586.1,282.5 z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#919191"
  },
  d: "M340.9,65.1c-23.1,10.4-47.5,22.1-73.5,34.7C47.5,206.2,161,435.8,161,435.8s70.5-26,163.3-59.4 C292.7,271.7,287.3,152,340.9,65.1z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#F5F5F5"
  },
  d: "M340.9,65.1c-53.6,86.8-48.1,206.5-16.6,311.2c113.8-40.9,261.2-93,353.3-122.1 C606.4-14.6,512.7-12.1,340.9,65.1z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#919191"
  },
  d: "M258.1,400.3c0,0,110.7-88.3,272.4-139.3c106.2-33.5,236.4-72.2,317-83.3c21.6-3,29.6,27.4,9.3,35.3 C743.7,257.2,510.4,346.7,258.1,400.3z"
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    opacity: 0.5,
    fill: "#FFFFFF"
  },
  points: "435.9,470.1 522.8,369.3 555.5,383.7 567.8,441.2 490.2,513.3"
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    opacity: 0.5,
    fill: "#FFFFFF"
  },
  points: "631.8,414.7 708.2,318.4 744.5,328.2 749.2,355.9 675.4,458.3 634.7,440.5"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#3C3C3C"
  },
  d: "M755.2,319.1c-4.1-12.1-14-20.4-25.1-21.8C664.4,289,613,324.5,594.4,340c-0.8,0.7-1.6,1.5-2.3,2.3 c-2.8,3.3-6.8,5.5-11.1,5.6c-5.5,0.2-10.8,1.3-15.8,3.5c-2,0.9-3.8,1.8-5.4,2.9c-3.5,2.2-7.7,2.6-11.8,1.7 c-0.9-0.2-1.7-0.3-2.6-0.4c-70.5-6.9-118.4,27.5-135.8,42.7c-2.9,2.5-5.2,5.7-6.7,9.3c-2.1,4.8-5.9,8.5-10.9,10.1L311.5,443 c0.2,0,0.3,0.1,0.5,0.1c12.2,4,21.7,12.5,29.4,22.6l52.9-16.7c6.6-2.1,13.7,1.4,16.1,8c9.2,25.7,23.9,54.7,50.9,69.1 c18.8,10,40.6,11.2,64.7,3.6c24.3-7.7,41.5-21.2,51.1-40.1c17.6-34.6,5.1-77.6-4.3-106c1.1-1.5,2.8-3.2,4.9-4.2 c3.3-1.4,7.3-1,11.1,0c8.6,28.7,23.1,70.3,57.2,88.5c18.8,10,40.6,11.2,64.7,3.6c24.3-7.7,41.5-21.2,51.1-40.1 C780.6,394.1,764.7,347.2,755.2,319.1z M549.7,475.7c-5.8,11.5-16.6,19.6-33,24.8c-16.3,5.1-29.7,4.7-41.1-1.4 c-25.7-13.7-37.4-53.6-44.4-77.4c-0.2-0.5-0.2-1-0.2-1.4c15.1-12.8,53.7-39.3,110-34.4c0.2,0.3,0.4,0.7,0.6,1.3 C549.5,410.6,562.8,450,549.7,475.7z M734.4,417.5c-5.8,11.5-16.6,19.6-33,24.8c-16.3,5.1-29.7,4.7-41.1-1.4 c-25.7-13.7-37.4-53.6-44.4-77.4c-0.2-0.5-0.2-1-0.2-1.4c15.1-12.8,53.7-39.3,110-34.4c0.2,0.3,0.4,0.7,0.6,1.2 C734.2,352.4,747.4,391.8,734.4,417.5z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#CFCFCF"
  },
  d: "M268.9,507c0,0,16.6-3.9,32.2,9.8c2.6,2.3,1.3,6.5-2.1,7.1c-8.2,1.3-15.6,9.2-13.4,34.8 c0,0,7.2-26.8,23.4-22.1c5.1,1.5,9.1,5.6,10.8,10.7c3.1,9.4,5.6,20.9,7,35C332.8,530.5,312.1,476.1,268.9,507z"
})))), /*#__PURE__*/React.createElement("ellipse", {
  style: {
    opacity: 0.25,
    fill: "#BCBEC0"
  },
  cx: 501.9,
  cy: 948,
  rx: 267.1,
  ry: 32.1
})));
export default SvgNoData;